import { getUserDetail } from 'api/user/user.query'
import { redirect } from 'react-router-dom'
import { permissionData } from 'shared/constants'
import allRoutes from 'shared/lib/allRoutes'
import { isUserLoggedIn, userLogOut } from 'shared/lib/user'

export const privateLoader = (queryClient) => async () => {
  const token = isUserLoggedIn()

  if (token) {
    try {
      const { data: user } = await queryClient.fetchQuery({ queryKey: ['getUserDetail'], queryFn: getUserDetail })
      return {
        token: token || null,
        user: user?.data,
        permissions: Object.values(permissionData)
      }
    } catch (error) {
      console.log(error)
      if (error.status === 401) {
        userLogOut()
        return redirect(`/?from=${window.location.pathname}${window.location.search || ''}`)
      }
      return null
    }
  } else {
    // return null
    return redirect(`/?from=${window.location.pathname}${window.location.search || ''}`)
  }
}

export const publicLoader = async () => {
  if (isUserLoggedIn()) return redirect(allRoutes.dashboard)
  else return null
}
